import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password aggiornata. Effettua il login.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-sm bg-white border border-line rounded-[8px] p-6">
        <h1 className="text-2xl font-semibold tracking-tight text-ink mb-4">Nuova password</h1>
        {!token ? (
          <p className="text-sm text-subtle">Token mancante. <Link className="text-brand-dark" to="/login">Torna al login</Link></p>
        ) : (
          <form onSubmit={submit} className="flex flex-col gap-4">
            <input
              data-testid="reset-password-input"
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white border border-line rounded-[6px] px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand transition-colors"
              placeholder="Nuova password (min 6)"
            />
            <button
              data-testid="reset-submit"
              disabled={loading}
              className="bg-brand text-ink font-medium rounded-[6px] px-4 py-2 hover:bg-brand-hover disabled:opacity-50 transition-colors"
            >
              {loading ? "Attendere…" : "Reimposta"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
